// extracted by mini-css-extract-plugin
export default {"ticketStyles":"format_ticketStyles__3PBqW","fragmentsStyles":"format_fragmentsStyles__aBzLo","icon":"format_icon__QFSGy"};